<script lang="ts" setup>
const { open } = useSearchModal()
</script>
<template>
  <HeaderActionButton class="hover" :aria-label="$t('search.form.button')" @click="open">
    <Icon name="search" />
  </HeaderActionButton>
  <ModalSearch />
</template>
